
import Cropper from './cropper.js';

const modal = document.querySelector('#crop-modal');
const crop = new Cropper(modal.querySelector('img'), {
	// aspectRatio: 1,
	autoCropArea: 1,
	minContainerHeight: 500,
	movable: false,
	rotatable: false,
	scalable: false
});

// modal.querySelector('input[name=modal-save-input]').addEventListener("keypress", function(event) {
// 	// alert('sdf');
//   if (event.key === "Enter") {
//     event.preventDefault();
//     onSaveAction();
//   }
// });


modal.querySelector('button[name=modal-save]').addEventListener('click', () => onSaveAction());
modal.querySelectorAll('button[name=close], button[name=modal-cancel]').forEach((btn) => { btn.addEventListener('click', () => cropHide()); });

let onSave;

const onSaveAction = () => {
	crop.getCroppedCanvas({
		width: 1400,
		height: 1400
	}).toBlob((blob) => {
		onSave(blob);
	});
	cropHide();
};

const cropShow = (imageFile, aspectRatio, onSv) => {
	modal.hidden = false;

	crop.setAspectRatio(aspectRatio);
	onSave = onSv;

	const reader = new FileReader();
	reader.onload = (e) => { crop.replace(e.target.result); };
	reader.readAsDataURL(imageFile);
	// modal.querySelector('input[name=modal-save-input]').focus();
};

const cropHide = () => {
	modal.hidden = true;
	modal.scrollTop = 0;
};

const drawImgSection = (opt, id) => `
	<section name="image"${id !== false ? 'class="hover-hidden-wrapper"' : ''}>
		<img name="image"  ${typeof opt.dataName !== 'undefined' ? `data-name="${opt.dataName}"` : ''} ${typeof opt.class !== 'undefined' ? `class="originalIMG ${opt.class}"` : ' class="originalIMG"'}>
		${id !== false ? `<div class="photo-uploader hover-hidden mt-3">
			<label for="${id}">
				<div class="w-100 column"><br>
					<img class="mlr-auto" src="/img/ic-upload.png">
					<span>Загрузить фото</span><br>
					<span class = "mlr-auto txt-al-center" name="image-delete"${typeof opt.onDelete !== 'undefined' ? '' : ' hidden'}>Удалить фото</span>
				</div>
			</label>
		</div>` : ''}
	</section>`;

const drawUplSection = (id) => `
	<section name="uploader" hidden>
		<input id="${id}" type="file" accept="image/*" hidden>
		<label for="${id}" class="uploader-dnd-area">
			<div>
				Нажмите для загрузки:<br>
				<img src="/img/ic-upload.png">
			</div>
		</label>
	</section>`;

const getRandInt = (max) => Math.floor(Math.random() * Math.floor(max));

const initCropper = (cropWrapNode, uplNode, opt) => {
	const isUplSecSet = uplNode !== false;
	let uplSec;

	if (!isUplSecSet) {
		const uploaderID = `image-uploader-${getRandInt(1000)}`;
		cropWrapNode.innerHTML = `${drawImgSection(opt, uploaderID)}${drawUplSection(uploaderID)}`;
		uplSec = cropWrapNode.querySelector('section[name="uploader"]');
	} else {
		uplSec = uplNode;
		cropWrapNode.innerHTML = `${drawImgSection(opt, false)}`;
	}

	const imgSec = cropWrapNode.querySelector('section[name="image"]');
	const img = imgSec.querySelector('img');

	if (typeof opt.url !== 'undefined')
		img.src = opt.url;

	uplSec.querySelector('input').addEventListener('change', (evt) => {
		cropShow(evt.target.files[0], opt.aspectRatio, (blob) => {
			img.src = URL.createObjectURL(blob);
			opt.onSave(blob);

			if (!isUplSecSet) uplSec.hidden = true;
			imgSec.hidden = false;
		});
	});

	if (typeof opt.onDelete !== 'undefined') {
		imgSec.querySelector('span[name="image-delete"]').addEventListener('click', (evt) => {
			evt.preventDefault();
			imgSec.hidden = true;
			if (!isUplSecSet) uplSec.hidden = false;
			opt.onDelete();
		});
	}
};
const setImage = (cropWrapNode, image) => {
	const imgSec = cropWrapNode.querySelector('section[name="image"]');
	const uplSec = cropWrapNode.querySelector('section[name="uploader"]');

	if (image === false) {
	  imgSec.hidden = true;
	  if (typeof uplSec !== 'undefined') uplSec.hidden = false;
	} else {
	  imgSec.querySelector('img').src = image;
	  imgSec.hidden = false;
	  if (typeof uplSec !== 'undefined') uplSec.hidden = true;
	}
};


export default {
	init: (cropWrapNode, uplNode, opt) => initCropper(cropWrapNode, uplNode, opt),
	setImg: setImage
};
